import Vue from 'vue';
import Vuex from 'vuex';
import ProgressBar from '@shared/progress-bar/progress-bar';
import Router from 'vue-router';
import shared from '@shared/shared-module';
import auth from '@modules/auth/auth-module';
import layout from '@modules/layout/layout-module';
import home from '@modules/home/home-module';
import iam from '@modules/iam/iam-module';
import settings from '@modules/settings/settings-module';
import propertySettings from '@modules/property-settings/property-settings-module';
import subpropertySettings from '@modules/subproperty-settings/subproperty-settings-module';
import subpropertyPeople from '@modules/subproperty-people/subproperty-people-module';
import programSettings from '@modules/subproperty-settings/program-settings/program-settings-module';
import paymentSettings from '@modules/subproperty-settings/finantial-settings/finantial-settings-module';
import customizeSettings from '@modules/subproperty-settings/customize-settings/customize-settings-module';
import auditLog from '@modules/audit-log/audit-log-module';
import academy from '@modules/academy/academy-module';
import player from '@modules/player/player-module';
import propertySetting from '@modules/property-setting/property-setting-module';
import coach from '@modules/coach/coach-module';
import parent from '@modules/parent/parent-module';
import news from '@modules/news/news-module';
import training from '@modules/training/training-module';
import game from '@modules/game/game-module';
import event from '@modules/event/event-module';
import team from '@modules/team/team-module';
import position from '@modules/position/position-module';
import fan from '@modules/fan/fan-module';
import sheetEvent from '@modules/sheet-event/sheet-event-module';
import site from '@modules/site/site-module';
import club from '@modules/club/club-module';
import service from '@modules/service/service-module';
import property from '@modules/property/property-module';
import program from '@modules/program/program-module';
import newsletter from '@modules/newsletter/newsletter-module';
import comment from '@modules/comment/comment-module';
import subproperty from '@modules/subproperty/subproperty-module';
// #
import category from '@modules/category/category-module';
import location from '@modules/location/location-module';
import season from '@modules/season/season-module';
import price from '@modules/price/price-module';
import paymentOption from '@modules/payment-option/payment-option-module';
import subprogram from '@modules/subprogram/subprogram-module';
import inscription from '@modules/inscription/inscription-module';
import family from '@modules/family/family-module';
import stripeConnectedAccount from '@modules/stripe/stripe-connected-account/stripe-connected-account-module';
import school from '@modules/school/school-module';
import stripePerson from '@modules/stripe/stripe-person/stripe-person-module';
import stripeExternalAccount from '@modules/stripe/stripe-external-account/stripe-external-account-module';
import stripePayout from '@modules/stripe/stripe-payout/stripe-payout-module';
import stripeBalance from '@modules/stripe/stripe-balance/stripe-balance-module';
import stripeWallet from '@modules/stripe/stripe-wallet/stripe-wallet-module';
import stripeCharge from '@modules/stripe/stripe-charge/stripe-charge-module';
import stripeIncome from '@modules/stripe/stripe-income/stripe-income-module';
import { get } from 'lodash';

const modules = {
  shared,
  home,
  settings,
  propertySettings,
  subpropertySettings,
  subpropertyPeople,
  programSettings,
  paymentSettings,
  customizeSettings,
  auth,
  iam,
  auditLog,
  layout,
  academy,
  player,
  propertySetting,
  coach,
  parent,
  news,
  training,
  game,
  event,
  team,
  position,
  fan,
  sheetEvent,
  site,
  club,
  service,
  property,
  category,
  program,
  newsletter,
  comment,
  subproperty,
  location,
  season,
  price,
  paymentOption,
  subprogram,
  inscription,
  family,
  school,
  stripeConnectedAccount,
  stripePerson,
  stripeExternalAccount,
  stripePayout,
  stripeWallet,
  stripeBalance,
  stripeCharge,
  stripeIncome,
};

// start - boilerplate code
const exists = (el) => !!el;

function setupComponentsFiltersDirectivesAndMixins() {
  Object.keys(modules)
    .map((key) => modules[key].components)
    .filter(exists)
    .forEach((components) => {
      components.forEach((component) => {
        Vue.component(component.name, component);
      });
    });

  Object.keys(modules)
    .map((key) => modules[key].filters)
    .filter(exists)
    .forEach((components) => {
      components.forEach((filter) => {
        Vue.filter(filter.name, filter.implementation);
      });
    });

  Object.keys(modules)
    .map((key) => modules[key].directives)
    .filter(exists)
    .forEach((directives) => {
      directives.forEach((directive) => {
        Vue.directive(
          directive.name,
          directive.implementation,
        );
      });
    });

  Object.keys(modules)
    .map((key) => modules[key].mixins)
    .filter(exists)
    .forEach((mixins) => {
      mixins.forEach((mixin) => {
        Vue.mixin(mixin);
      });
    });
}

const routes = [
  ...Object.keys(modules)
    .filter((key) => !!modules[key].routes)
    .map((key) => modules[key].routes)
    .reduce((a, b) => a.concat(b), []),
  { path: '*', redirect: '/404' },
];

let router = null;

const routerAsync = () => {
  if (!router) {
    router = new Router({
      routes,
      scrollBehavior() {
        return { x: 0, y: 0 };
      },
    });

    router.beforeEach((to, from, next) => {
      ProgressBar.start();
      const toRouteName = get(to, 'query.toRouteName', null);

      if (toRouteName) {
        ProgressBar.done();
        return next({ name: toRouteName });
      }
        
      if (to.name) {
        if (to.name === 'home') {
          let path;
          const currentManage = storeAsync().getters['auth/manage/currentManage'];
          if (currentManage.type === 'property') path = '/property';
          if (currentManage.type === 'subproperty') path = '/subproperty';
          if (path) {
            ProgressBar.done();
            return next(path);
          }
        }
      }

      next();
    });

    router.afterEach(ProgressBar.done);
  }

  return router;
};

const buildStores = () => {
  const output = {};

  Object.keys(modules)
    .filter((key) => !!modules[key].store)
    .forEach((key) => {
      output[key] = modules[key].store;
    });

  return output;
};

let store = null;

const storeAsync = () => {
  if (!store) {
    store = new Vuex.Store({ modules: buildStores() });
  }

  return store;
};

export {
  setupComponentsFiltersDirectivesAndMixins,
  routerAsync,
  storeAsync,
};

// end - boilerplate code
